export const styles: string[] = [
  `
      @page {
        size: auto; /* auto is the initial value */
      }
      * {
        line-height: 1em;
        font-size: 12px;
        box-sizing: border-box;
      } 
      div.signature.big * * {
        font-size: 18px!important;
        line-height: 23px!important;
      }
      .justify-content {
        display: block !important;
        justify-content: initial !important;
      }
      .class {
        float: right;
      }
      .title {
        position: relative;
        z-index: 2;
        display: block;
        max-width: 180px;
        max-height: 1em;
        overflow: hidden;
      }
      .library {
        display: block;
        width: 100%;
        text-align: center;
      }
      svg {
        margin-top: -20px;
        margin-bottom: 4px;
        justify-content: center;
        width: 100%;
      }
      media-barcode,
      reader-barcode, media-signature {
        display: block;
        float: left;
        padding-top: 6px;
      }
      * {
        font-family: sans-serif;
        box-sizing: border-box;
      }
      /*.barcode-container:last-child media-barcode, .barcode-container:last-child reader-barcode {
        max-height: 25mm;
      }*/

      .color-rectangle {
        display: inline-block; 
        width: 1rem;
        height: 1rem;
        margin-left: 8px;
        position: relative;
        top: 1px;
        border-radius: 20px;
      }
      img + span.color-rectangle {
        margin-top: 3px;
        margin-right: 12px;
        margin-left: 16px;
      }
      .sign {
        border-radius: 40px;
        max-width: 100%;
        width: 3cm;
        display: inline-block
      }
    `,
];
